/* FESCHD 22.10.2026 Lead-Seiten: Anmeldefeld ohne Klaviyo-Onsite-Skript.
   Sendet die E-Mail beim Absenden an die Klaviyo Client Subscriptions API (oeffentlicher Site-Key, keine Geheimnisse),
   die Liste entscheidet ueber Double-Opt-in. Danach Weiterleitung (im Theme-Preview mit preview_theme_id). UTM-Parameter der URL
   werden als Profil-Eigenschaften mitgegeben. Idempotent (data-ready), erneut aufrufbar bei Section-Reload im Editor. */
(function () {
  window.FESCHD = window.FESCHD || {};
  if (window.FESCHD.leadSignup) {
    window.FESCHD.leadSignup();
    return;
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function params() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return null;
    }
  }

  function utmProps() {
    var out = {};
    var p = params();
    if (!p) return out;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      var val = p.get(key);
      if (val) out[key] = val;
    });
    return out;
  }

  function withPreview(url) {
    var p = params();
    var preview = p && p.get('preview_theme_id');
    if (!preview || url.indexOf('preview_theme_id') > -1) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(preview);
  }

  function init() {
    document.querySelectorAll('[data-feschd-signup]:not([data-ready])').forEach(function (form) {
      form.setAttribute('data-ready', '');
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');
      var error = form.querySelector('[data-signup-error]');

      function fail(message) {
        error.textContent = message;
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        button.disabled = false;
        input.focus();
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var email = (input.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          fail(form.getAttribute('data-msg-invalid'));
          return;
        }
        error.hidden = true;
        input.removeAttribute('aria-invalid');
        button.disabled = true;

        var source = form.getAttribute('data-source') || 'Lead-Landingpage';
        var props = utmProps();
        props.signup_source = source;

        var body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: form.getAttribute('data-list') } } }
          }
        };

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.getAttribute('data-site')), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify(body)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('status ' + response.status);
            var redirect = form.getAttribute('data-redirect');
            if (redirect) {
              window.location.href = withPreview(redirect);
            } else {
              form.innerHTML = '<p class="feschd-lead__signup-done">' + form.getAttribute('data-msg-done') + '</p>';
            }
          })
          .catch(function () {
            fail(form.getAttribute('data-msg-error'));
          });
      });
    });
  }

  window.FESCHD.leadSignup = init;
  document.addEventListener('shopify:section:load', init);
  init();
})();
